import React from "react";
import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { SectionHeader, Loading, EmptyState } from "@/components/brand";
import { ChallengeCard } from "@/components/cards";

export default function Challenges() {
  const challenges = useQuery({ queryKey: ["challenges"], queryFn: () => api("/challenges") });
  const badges = useQuery({ queryKey: ["me", "badges"], queryFn: () => api("/me/badges") });

  return (
    <div data-testid="challenges-screen" className="space-y-6">
      <SectionHeader title="Challenges" subtitle="Join, train, climb the leaderboard." />
      {badges.data ? (
        <div className="flex items-center gap-4 p-4 rounded-xl2 bg-ink text-white">
          <div><div className="font-display text-3xl text-brand">{badges.data.points}</div><div className="font-body text-xs text-white/70">points</div></div>
          <div className="h-10 w-px bg-white/20" />
          <div><div className="font-display text-3xl text-brand">{badges.data.badges?.length ?? 0}</div><div className="font-body text-xs text-white/70">badges earned</div></div>
        </div>
      ) : null}
      {challenges.isLoading ? <Loading /> : (challenges.data ?? []).length === 0 ? (
        <EmptyState title="No challenges yet" subtitle="Check back soon for new challenges." />
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">{(challenges.data ?? []).map((c) => <ChallengeCard key={c.id} item={c} />)}</div>
      )}
    </div>
  );
}
